import { gql } from 'graphql-request';

export const SEARCH_USERS = gql`
  query SearchUsers($emailSearch: citext) {
    user(
      where: {
        _or: [{ email: { _ilike: $emailSearch } }]
        isActive: { _eq: true }
        userGroup: { _nin: ["BETA", "ADMIN"] }
      }
      limit: 20
      orderBy: { firstName: ASC }
    ) {
      id
      firstName
      lastName
      email
      dateJoined
      userGroup
    }
  }
`;

export const GET_BETA_USERS = gql`
  query GetBetaUsers {
    user(where: { userGroup: { _eq: "BETA" }, isActive: { _eq: true } }, orderBy: { firstName: ASC }) {
      id
      firstName
      lastName
      email
      dateJoined
      userGroup
    }
  }
`;

export const UPDATE_USER_GROUP = gql`
  mutation UpdateUserGroup($userId: uuid!, $userGroup: String!) {
    updateUserByPk(pkColumns: { id: $userId }, _set: { userGroup: $userGroup }) {
      id
      firstName
      lastName
      email
      dateJoined
      userGroup
    }
  }
`;
